<template>
  <div class="bind-phone">
    <div class="register-form">
      <div class="title">绑定手机号</div>
      <div class="input-group input-phone">
        <div class="input-label"><img class="icon-img" src="../assets/icon-login-phone.png"></div>
        <input class="mint-field-core form-input" v-model="phone" type="number" placeholder="请输入手机号">
        <div class="phone-code" :class="{'wait-send': waitSend}" @click="sendCode()">{{sendButtonText}}</div>
      </div>
      <div class="input-group">
        <div class="input-label">
          <img class="icon-lock" src="../assets/icon-code.png">
        </div>
        <input class="mint-field-core form-input" v-model="code" placeholder="请输入验证码">
      </div>
      <div class="form-btn" @click="bindPhone" >绑定</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import codeService from '../service/phoneCode/CodeService'
  import customerUserService from '../service/customer/UserService'
  import session from '../utils/Session'

  export default {
    name: 'RegisterStepTwo',
    data () {
      return {
        openId:'',
        phone: '',
        code:'',
        password:'',
        sendStatus: false,
        sendTime: 60,
        sendButtonText: '获取验证码',
        waitSend:false,
        regBtnActived:false
      }
    },
    created(){
      this.openId = session.getOpenId();
    },
    beforeMount () {

    },
    methods: {
      checkPhone(){
        let phone = this.phone;
        if (phone == '') {
          Toast('请输入手机号码！');
          return false;
        }
        let re= /^1[3578]\d{9}$/;
        if(re.test(phone)){
          return true;
        } else {
          Toast('请输入11位手机号码！');
          return false;
        }
      },
      async sendCode(){//发送验证码
        if (!this.checkPhone()) {
          return;
        }
        this.sendStatus = true;
        let result = await codeService.sendPhoneCode(this.phone,1);
        if(result.code == '0'){
          Toast('验证码已发送至您的手机,请注意查收！');
          this.sendTime = 60;
          this.computeSendTime();
        }else {
          Toast('获取验证码失败');
        }
      },
      computeSendTime () {
        if (this.sendStatus) {
          if (this.sendTime == 0) {
            this.waitSend = false;
            this.sendStatus = false;
            this.sendButtonText = '重新获取'
          } else {
            this.waitSend = true;
            this.sendTime = this.sendTime - 1;
            this.sendButtonText = this.sendTime + '秒';
            setTimeout(() => {
              this.computeSendTime()
            }, 1000)
          }
        }
      },
      async bindPhone(){
        if (!this.checkPhone()) {
          return;
        }
        if (this.code == null || this.code == '') {
          Toast('请填写验证码!');
        } else {
          let result = await codeService.checkPhoneCode(this.code, '1',this.phone);
          if (result.code == '0') {
            let openid = this.openId;
            let unionid = session.getUnionId();
            let userType = session.getUserType();
            let nickname = session.getNickname();
            let avatarUrl = session.getAvatar();
            let res = await customerUserService.bindPhone(unionid,openid,this.phone,nickname,avatarUrl,userType);
            if (res.code == '0') {
              Toast('绑定手机号成功!');
              session.openId(this.openId);
              this.loginByPhone(this.phone);
            }else {
              Toast(res.msg);
            }
          }
        }
      },
      async loginByPhone(phone){
        let that = this;
        let res=await customerUserService.phoneLogin(phone);
        if(res.code == '0'){
          session.accountToken(res.data);
          session.login(res.data);
          let backUrl = session.getBackUrl() || '';
          if(!backUrl){
            this.$router.push({name:'Home',params:{}});
          }else {
            this.$router.push(backUrl);
          }
        }else {
          Toast("登录失败，请稍后重试!");
        }
      },
      //创建Nim
      newNim() {
        let that = this;
        console.log("查看是否支持数据库==================" + NIM.support.db)
        this.global.nim = NIM.getInstance({
          //控制台日志，上线时应该关掉
          debug: true || { api: 'info', style: 'font-size:14px;color:blue;background-color:rgba(0,0,0,0.1)' },
          appKey: window.CONFIG.appkey,

          //数据库
          db:true,
          //连接
          onconnect: that.onConnect.bind(this),
          ondisconnect: that.onDisconnect.bind(this),
          account: session.getAccountToken().openid,
//          account: 'helloworld',
          token: session.getEaseToken(),
//          token: 'cc1534508ef97a71851b211b3d97febe',
          // 会话
          onsessions: that.onSessions.bind(this),
          onupdatesession: that.onUpdateSession.bind(this),
          // 消息
          onroamingmsgs: that.onRoamingMsgs.bind(this),
          onofflinemsgs: that.onOfflineMsgs.bind(this),
          onmsg: that.onMsg.bind(this)
        });
        this.global.nim.connect();
      },
      onConnect(obj) {
        console.log('-------- onConnect', obj)
      },
      onDisconnect(obj) {
        console.log('--------- onDisconnect', obj)
      },
      onSessions(obj) {
        console.log('== Contact == onSessions() 方法,收到会话列表', obj)

        if (this.global.setContactList != null) {
          console.log('收到会话列表  this.global.setContactList != null')
          this.global.setContactList.setContact(obj);
        } else {
          console.log('收到会话列表  this.global.setContactList 为 null')
          let objList = [];
          for (let i = 0; i < obj.length; i ++) {
            if (obj[i].lastMsg.from.toLowerCase() != session.getAccountToken().openid.toLowerCase()) {
              objList.push(obj[i]);
            }
          }
          this.global.contactsList = objList;
        }
        this.countMsgNum();
      },
      onUpdateSession(obj) {
        let that = this;
        console.log('== Contact == onUpdateSession() 方法，会话列表更新  obj.lastMsg.from = ' + obj.lastMsg.from.toLowerCase() + "   session.getOpenId().toLowerCase() = " + session.getAccountToken().openid.toLowerCase(), obj)
        if (obj.lastMsg.from.toLowerCase() != session.getAccountToken().openid.toLowerCase()) {

          if (this.global.setContactList != null) {
            console.log('== Contact == onUpdateSession() 方法，会话列表更新  IF  ', obj)
            this.global.setContactList.pushContact(obj);
            console.log('== Contact == onUpdateSession() 方法，会话列表更新  this.global.contactsList  ', this.global.contactsList)
          } else {
            console.log('== Contact == onUpdateSession() 方法，会话列表更新  ELSE  ', obj)
            //相同的更新，不同的增加
            let hasIt = false;
            for (let i = 0; i < that.global.contactsList.length; i++) {
              if (that.global.contactsList[i].lastMsg.from.toLowerCase() == obj.lastMsg.from.toLowerCase()) {
                that.global.contactsList[i] = obj;
                hasIt = true;
              }
            }
            if (!hasIt) {
              console.log("Auth.vue -onUpdateSession- 里面没有，push");
              that.global.contactsList.push(obj);
            }
            console.log('== Contact == onUpdateSession() 方法，会话列表更新  this.global.contactsList  ', this.global.contactsList)
          }
          that.countMsgNum();
        }
      },
      onRoamingMsgs(obj) {
        if (this.global.setLetterList != null) {
          console.log('== Contact == onRoamingMsgs()， 漫游消息 方法  IF', obj)
          this.global.setLetterList.getMsg(obj)
        } else {
          console.log('== Contact == onRoamingMsgs()， 漫游消息 方法  ELSE', obj)
          this.global.letterList.push(obj);
        }
      },
      onOfflineMsgs(obj) {
        if (this.global.setLetterList != null) {
          this.global.setLetterList.getMsg(obj)
          console.log('== Contact == onOfflineMsgs() 方法, 离线消息 IF  ', obj)
        } else {
          console.log('== Contact == onOfflineMsgs() 方法, 离线消息 ELSE ', obj)
          this.global.letterList.push(obj);
        }
      },
      onMsg(obj) {
        if (this.global.setLetterList != null) {
          console.log('== Contact == onMsg(), 收到消息 方法 IF', obj)
          this.global.setLetterList.getMsg(obj)
        } else {
          console.log('== Contact == onMsg(), 收到消息 方法 ELSE', obj)
          this.global.letterList.push(obj);
        }
      },
      countMsgNum() {
        let that = this;
        let num = 0;
        for (let i = 0; i < that.global.contactsList.length; i++) {
          console.log("countMsgNum 方法 第 " +i + "项未读条数:" + that.global.contactsList[i].unread)
          num += that.global.contactsList[i].unread;
        }
        this.global.msgCountGlobal = num;
        if (this.global.setMsgCount != null) {
          this.global.setMsgCount(num);
        }
        console.log("countMsgNum 方法 总的未读条数:" + num);
      }
    }
  }
</script>
<style lang="scss">
  .bind-phone{
    width: 7.5rem;
    height: 11.8rem;
    font-size: 0.36rem;
    color: #878e99;
    margin-top: -1rem;
    display: flex;
    background: white url("../assets/icon-login-bg.png") no-repeat;
    background-position: center;
    background-size: cover;
    .register-form{
      width: 6.94rem;
      height: 7.1rem;
      margin: 2.1rem auto 0 auto;
      background-color: white;
      border-radius: 0.1rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
      .title{
        height: 1.2rem;
        line-height: 1.2rem;
        margin-left: 0.3rem;
        color: #191818;
        font-weight: bold;
      }
    }
    .input-group{
      height: 0.9rem;
      width: 6.54rem;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      font-size: .26rem;
      color: #191818;
      margin: 0rem auto 0.28rem;
      border-bottom: solid 1px #e0dedc;
    }
    .input-group .input-label{
      width: 0.28rem;
      height: 0.42rem;
      padding-left:0.34rem;
      padding-right:.15rem;
      flex-grow: 0;
      flex-shrink: 0;
    }
    .input-label .icon-lock{
      width: 0.36rem;
    }
    .input-label .icon-img{
      width: 100%;
      height: 100%;
    }
    .input-group .form-input{
      border: none;
      width: 4.5rem;
      padding-left: .2rem;
      flex-grow: 1;
      outline: none;
      height: 0.78rem;
      font-size: .26rem;
      line-height: 0.78rem;
    }
    .input-phone{
      margin-top: 0.5rem;
      margin-bottom: 0.28rem;
    }
    .phone-code {
      width: 2.2rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.06rem;
      color: #feac00;
    }
    .form-btn{
      width: 2.8rem;
      height: 0.9rem;
      margin: 0.94rem auto 0rem auto;
      color: white;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 0.45rem;
      background: #feac00;
    }
    .form-btn-unactived{
      width: 2.8rem;
      height: 0.9rem;
      margin: 0.94rem auto 0rem auto;
      color: #878E99;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 0.45rem;
      background-color: #e0dedc;
    }

    *::-webkit-input-placeholder { /* WebKit browsers*/
      color:#D5DEE2!important;
      font-size:.28rem!important;
      padding-top:0.02rem;
    }
    *:-moz-placeholder {  /* Mozilla Firefox 4 to 18*/
      color:#D5DEE2!important;
      font-size:.28rem!important;
      padding-top:0.02rem;
    }
    *::-moz-placeholder {  /* Mozilla Firefox 19+*/
      color:#D5DEE2!important;
      font-size:.28rem!important;
      padding-top:0.02rem;
    }
    *:-ms-input-placeholder { /* Internet Explorer 10+*/
      color:#D5DEE2!important;
      font-size:.28rem!important;
      padding-top:0.02rem;
    }
    .wait-send {
      pointer-events: none;
    }
  }

</style>
